// Vendors
import React from 'react';
import { Typography } from '@mui/material';

// Components
import ReusablePopup from '@/components/organism/PopUp/ReusablePopup/ReusablePopup';

// Store
import { Equipment } from '@/api/models/Contracts';
import { POPUP_TYPES } from '@/utils/constants';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  data: Equipment;
}

const EquipmentDetailsPopup: React.FC<Props> = ({ isOpen, onClose, data }) => {
  // const formatAmount = (value: string): string => {
  //   if (value) {
  //     const clean = value.replace(/,/g, '').trim();

  //     const number = parseFloat(clean);
  //     if (isNaN(number)) return value;
  //     return number.toLocaleString('en-US', {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2,
  //     });
  //   } else return '';
  // };
  return (
    <ReusablePopup
      isOpen={isOpen}
      onClose={onClose}
      typeClassName="contract-details-popup"
      type={POPUP_TYPES.EQUIPMENT_DETAILS}
      header={`${data.madeBy} ${data.model}`}
    >
      {data.vin && 
      <Typography className="popup-content">VIN: {data.vin}</Typography>
      }
      {/* <Typography className="popup-content">
        Value: ${formatAmount(data.value.toString())}
      </Typography> */}
      <Typography className="popup-content">Equipment Code: {data.equipmentCode}</Typography>
      <Typography className="popup-content"> {data.description}</Typography>
    </ReusablePopup>
  );
};

export default EquipmentDetailsPopup;
